import { DISPLAY_UNIT_KG } from "../../utils/formatters";

/**
 * 목표·이행계획·조직경계 할당 API 저장 단위 (인벤토리·대시보드 overview와 동일)
 */
export const TARGET_STORAGE_UNIT = DISPLAY_UNIT_KG;

export function targetStorageUnitLabel() {
    return TARGET_STORAGE_UNIT;
}

/**
 * @param {number|string|null|undefined} value
 * @param {(n: number|string) => string} formatNumber
 */
export function formatTargetEmissionValue(value, formatNumber) {
    if (value == null || value === "") return "-";
    return `${formatNumber(value)} ${TARGET_STORAGE_UNIT}`;
}
